var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/utils.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/utils.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("staticUrl")) {
var t_4 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_4);
if(t_1.hasOwnProperty("staticLibUrl")) {
var t_5 = t_1.staticLibUrl;
} else {
cb(new Error("cannot import 'staticLibUrl'")); return;
}
context.setVariable("staticLibUrl", t_5);
if(t_1.hasOwnProperty("genericUrl")) {
var t_6 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_6);
var macro_t_7 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_8 = "";if((lineno = 17, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, []))) {
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_8);
});
context.addExport("eval");
context.setVariable("eval", macro_t_7);
var macro_t_9 = runtime.makeMacro(
["src"], 
["qs", "includeDefer", "includeAsync"], 
function (l_src, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("src", l_src);
frame.set("qs", kwargs.hasOwnProperty("qs") ? kwargs["qs"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("includeDefer", kwargs.hasOwnProperty("includeDefer") ? kwargs["includeDefer"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("includeAsync", kwargs.hasOwnProperty("includeAsync") ? kwargs["includeAsync"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_10 = "";var t_11;
t_11 = (function() {
var output = "";
t_10 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "includeDefer")) {
t_10 += "\n            defer\n        ";
;
}
t_10 += "\n    ";
;
return output;
})()
;
frame.set("deferSnippet", t_11, true);
if(frame.topLevel) {
context.setVariable("deferSnippet", t_11);
}
if(frame.topLevel) {
context.addExport("deferSnippet", t_11);
}
t_10 += "\n\n    ";
var t_12;
t_12 = (function() {
var output = "";
t_10 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "includeAsync")) {
t_10 += "\n            async=true\n        ";
;
}
t_10 += "\n    ";
;
return output;
})()
;
frame.set("asyncSnippet", t_12, true);
if(frame.topLevel) {
context.setVariable("asyncSnippet", t_12);
}
if(frame.topLevel) {
context.addExport("asyncSnippet", t_12);
}
if(runtime.contextOrFrameLookup(context, frame, "qs")) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cacheBuster")) {
t_10 += "<script type=\"text/javascript\" src=\"";
t_10 += runtime.suppressValue((lineno = 43, colno = 59, runtime.callWrap(t_6, "genericUrl", context, ["/orchestration" + "" + l_src,"v=" + "" + env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cacheBuster"),"") + "" + env.getFilter("safe").call(context, "&") + "" + env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "qs"))])), env.opts.autoescape);
t_10 += "\" ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "asyncSnippet"), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "deferSnippet"), env.opts.autoescape);
t_10 += "></script>";
;
}
else {
t_10 += "<script type=\"text/javascript\" src=\"";
t_10 += runtime.suppressValue((lineno = 45, colno = 59, runtime.callWrap(t_6, "genericUrl", context, ["/orchestration" + "" + l_src,"v=" + "" + env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "qs"))])), env.opts.autoescape);
t_10 += "\" ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "asyncSnippet"), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "deferSnippet"), env.opts.autoescape);
t_10 += "></script>";
;
}
;
}
else {
t_10 += "<script type=\"text/javascript\" src=\"";
t_10 += runtime.suppressValue((lineno = 48, colno = 55, runtime.callWrap(t_6, "genericUrl", context, ["/orchestration" + "" + l_src,"v=" + "" + env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cacheBuster"),"")])), env.opts.autoescape);
t_10 += "\" ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "asyncSnippet"), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "deferSnippet"), env.opts.autoescape);
t_10 += "></script>";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("orchestration_include");
context.setVariable("orchestration_include", macro_t_9);
var macro_t_13 = runtime.makeMacro(
["src"], 
["type", "qs", "extra_tag"], 
function (l_src, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("src", l_src);
frame.set("type", kwargs.hasOwnProperty("type") ? kwargs["type"] : "js");
frame.set("qs", kwargs.hasOwnProperty("qs") ? kwargs["qs"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("extra_tag", kwargs.hasOwnProperty("extra_tag") ? kwargs["extra_tag"] : "");
var t_14 = "";var t_15;
t_15 = (lineno = 63, colno = 24, runtime.callWrap(t_4, "staticUrl", context, [l_src,(lineno = 63, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "buildStaticQueryString"), "buildStaticQueryString", context, [runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "qs")]))]));
frame.set("url", t_15, true);
if(frame.topLevel) {
context.setVariable("url", t_15);
}
if(frame.topLevel) {
context.addExport("url", t_15);
}
if(runtime.contextOrFrameLookup(context, frame, "type") == "js") {
t_14 += "<script type=\"text/javascript\" src=\"";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
t_14 += "\" ";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "extra_tag"), env.opts.autoescape);
t_14 += "></script>";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "css") {
t_14 += "<link rel=\"stylesheet\" href=\"";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
t_14 += "\" ";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "extra_tag"), env.opts.autoescape);
t_14 += " />";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
context.addExport("cache_buster_include");
context.setVariable("cache_buster_include", macro_t_13);
var macro_t_16 = runtime.makeMacro(
["src"], 
["type"], 
function (l_src, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("src", l_src);
frame.set("type", kwargs.hasOwnProperty("type") ? kwargs["type"] : "js");
var t_17 = "";var t_18;
t_18 = (lineno = 73, colno = 27, runtime.callWrap(t_5, "staticLibUrl", context, [l_src,(lineno = 73, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "buildStaticQueryString"), "buildStaticQueryString", context, [runtime.contextOrFrameLookup(context, frame, "core")]))]));
frame.set("url", t_18, true);
if(frame.topLevel) {
context.setVariable("url", t_18);
}
if(frame.topLevel) {
context.addExport("url", t_18);
}
if(runtime.contextOrFrameLookup(context, frame, "type") == "js") {
t_17 += "<script type=\"text/javascript\" src=\"";
t_17 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
t_17 += "\"></script>";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "type") == "css") {
t_17 += "<link rel=\"stylesheet\" href=\"";
t_17 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "url"), env.opts.autoescape);
t_17 += "\" />";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
context.addExport("static_lib_include");
context.setVariable("static_lib_include", macro_t_16);
var macro_t_19 = runtime.makeMacro(
["attr", "value"], 
[], 
function (l_attr, l_value, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("attr", l_attr);
frame.set("value", l_value);
var t_20 = "";if(l_value && l_value != "undefined") {
t_20 += runtime.suppressValue(l_attr + "" + "=" + "" + l_value, env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
context.addExport("create_attr");
context.setVariable("create_attr", macro_t_19);
var macro_t_21 = runtime.makeMacro(
["core"], 
["qs"], 
function (l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("core", l_core);
frame.set("qs", kwargs.hasOwnProperty("qs") ? kwargs["qs"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_22 = "";if(runtime.memberLookup((l_core),"cacheBuster") && (lineno = 93, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.envVars.environment"])) != "prod") {
t_22 += "v=";
t_22 += runtime.suppressValue(runtime.memberLookup((l_core),"cacheBuster"), env.opts.autoescape);
;
}
if(runtime.contextOrFrameLookup(context, frame, "qs")) {
var t_23;
t_23 = (runtime.memberLookup((l_core),"cacheBuster")?env.getFilter("safe").call(context, "&"):"");
frame.set("delim", t_23, true);
if(frame.topLevel) {
context.setVariable("delim", t_23);
}
if(frame.topLevel) {
context.addExport("delim", t_23);
}
t_22 += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "delim") + "" + env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "qs"))), env.opts.autoescape);
;
}
if(runtime.memberLookup((l_core),"cacheBusterOverride")) {
t_22 += runtime.suppressValue(runtime.memberLookup((l_core),"cacheBusterOverride"), env.opts.autoescape);
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
context.addExport("buildStaticQueryString");
context.setVariable("buildStaticQueryString", macro_t_21);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/utils.j2"] , dependencies)